import cn from 'classnames';
import DealProductBox from '../DealProductCard';
import { TopDealProduct } from '../types';
import Wrapper from './Wrapper';

const Spotlight = ({
  spotlightDeals,
}: {
  spotlightDeals: TopDealProduct[] | undefined;
}) => (
  // Display the spotlight section only if the total number of deals is greater than or equal to SPOTLIGHT_DEALS_COUNT
  <Wrapper>
    <div className="flex flex-col gap-3 px-3 pb-3 3xs:grid 3xs:grid-cols-2 md:grid-cols-3 md:px-5 md:pb-5 lg:grid-cols-4 xl:grid-cols-5">
      {spotlightDeals?.map((deal, index) => (
        <div className={cn({ '3xs:col-span-2': index === 0 })} key={deal.sku}>
          <DealProductBox
            isSpotlight={index === 0}
            deal={deal}
            index={index}
            key={deal.productId}
          />
        </div>
      ))}
    </div>
  </Wrapper>
);

export default Spotlight;
